import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "list-group" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "badge mx-3 bg-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event, ix) => {
        return (_openBlock(), _createElementBlock("a", {
          key: ix,
          type: "button",
          class: _normalizeClass(["list-group-item list-group-item-action btn btn-primary", { active: ix === 0 }]),
          href: event.href,
          "aria-current": "true"
        }, [
          _createElementVNode("span", null, _toDisplayString(event.title), 1),
          (event.href !== '#')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, " >>> "))
            : _createCommentVNode("", true),
          _createElementVNode("b", _hoisted_5, _toDisplayString(event.date), 1)
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}